import apiClient from '../apiClient';
import { UPLOAD_COMMIT_TRANSPORTATION_PROFILE_URL } from '../apiUrl';

const uploadMasterTransportationProfileApi = data => {
  return apiClient.post(UPLOAD_COMMIT_TRANSPORTATION_PROFILE_URL, data);
};

export default uploadMasterTransportationProfileApi;
